import { render } from "./EditDetailedCompetencesModal.vue?vue&type=template&id=17082901&scoped=true"
import script from "./EditDetailedCompetencesModal.vue?vue&type=script&lang=js"
export * from "./EditDetailedCompetencesModal.vue?vue&type=script&lang=js"

import "./EditDetailedCompetencesModal.vue?vue&type=style&index=0&id=17082901&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17082901"]])

export default __exports__